import { IHubspotForm } from 'models/hubspotForm';

export interface IFooter {
  id: number;
  name: string;
  hubspot_form_id?: string;
  hubspot_form?: IHubspotForm;
}

export const FooterType = {
  STANDARD: 'standard',
  COMPACT: 'compact',
} as const;

export type IFooterType = (typeof FooterType)[keyof typeof FooterType];
